import { render } from "./ListFeature.vue?vue&type=template&id=14b14dae"
import script from "./ListFeature.vue?vue&type=script&lang=js"
export * from "./ListFeature.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__